<template>
  <div>
    <v-carousel hide-delimiters height="90vh">
      <v-carousel-item
        v-for="(item, i) in items"
        contain
        :key="i"
        :src="item.src"
      ></v-carousel-item>
    </v-carousel>
    <a
      href="https://drive.google.com/file/d/14bU5-OCm6HoBzFwK497ksYPWK1KJQfLW/view?usp=sharing"
      download
      target="_black"
    >
      <v-btn absolute dark top color="red">
        <v-icon>PDF 다운로드</v-icon></v-btn
      ></a
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: require("../img/brochure/dae-shin0.jpg"),
        },
        {
          src: require("../img/brochure/dae-shin1.jpg"),
        },
        {
          src: require("../img/brochure/dae-shin2.jpg"),
        },
        {
          src: require("../img/brochure/dae-shin3.jpg"),
        },
        {
          src: require("../img/brochure/dae-shin4.jpg"),
        },
        {
          src: require("../img/brochure/dae-shin5.jpg"),
        },
        {
          src: require("../img/brochure/dae-shin6.jpg"),
        },
        {
          src: require("../img/brochure/dae-shin7.jpg"),
        },
        {
          src: require("../img/brochure/dae-shin8.jpg"),
        },
        {
          src: require("../img/brochure/dae-shin9.jpg"),
        },
        {
          src: require("../img/brochure/dae-shin10.jpg"),
        },
      ],
    };
  },
};
</script>
